import React from 'react';
import { connect } from 'react-redux';
import {changeItemQuantity} from '../../actions/store/itemCardActions';
import QuantityUpdater from '../common/QuantityUpdater';
import {getItemPrice, formatMoney, formatCredits} from '../../common/basket';
import {setNoItemImage} from '../../common/utils';
import {push} from "react-router-redux";
import {CART_ITEM_QRY, CATEGORY_QRY} from "../../common/constants";

class StoreOrderSummaryItem extends React.Component {
    onRemoveButtonClick = () => {
		this.props.changeItemQuantity(this.props.item, this.props.item.minQuantity||0, this.props.item.quantity, this.props.creditsData);
	};

    getDetails = (item, price, extraCreditItem) => {
	    const itemTitle = item.key !== extraCreditItem.key?item.title:item.title?item.title.replace("Credit",this.props.serverStaticData.creditItemLabel):item.title;
	    const points = this.props.serverStaticData.showItemPoints && item.points ?
            <span className="points"> / {item.points} p. </span>
            : '';
        return (
            <div className="item-details" onClick={() => this.openDetails(item)}>
                <div className="title" name="orderSummaryItemName">{itemTitle}</div>
                {
                    item.key !== extraCreditItem.key?
                    <div className="price" name="orderSummaryItemPrice">{price} {points}<span className="unit">{item.unit?" / " + item.unitQuantity +" " + item.unit.replace("credits",this.props.serverStaticData.creditItemLabel) :undefined} </span></div>:
                    <div className="price" name="orderSummaryItemPrice">{price} </div>
                }
            </div>)
    };

    openDetails = (item) => {
        let itemObj = this.props.allItems[item.key];
        this.props.openDetailsBox(item.category, itemObj.defaultBoxItem || item.key);
    };

    isExisting = (propsReadonly, itemKey, extraCreditItemKey) => {
      return propsReadonly || itemKey === extraCreditItemKey;
    };

    getQuantityAndTotal = (item, price, extraCreditItem) => {
      return (
          <div className="quantity-and-total-wrapper">
              <div className={this.isExisting(this.props.readonly, item.key, extraCreditItem.key) ? 'item-exist' : 'item-not-exist'}><span className="order-summary-item-qty" name="orderSummaryItemQty">
                                {
                                    this.props.readonly || item.key === extraCreditItem.key
                                        ? formatCredits(item.quantity)
                                        : <QuantityUpdater item={item} isOrderSummary={true} allowChange={true} staticData={this.props.serverStaticData}/>
                                }
                                                                </span>
          </div>
              {!item.isCredit?
                  <div className="order-summary-item-total"
                         name="orderSummaryItemTotal">{formatMoney(item.quantity * (getItemPrice(item, this.props.serverStaticData).priceBeforeTax))}</div>:
                  <div className="order-summary-item-total"
                             name="orderSummaryItemTotal">{!this.props.serverStaticData.isCreditItemAsRegularItem?
                      formatCredits(item.quantity * item.price):formatMoney(item.quantity * item.price)}</div>
          }
          </div>);
    };

    getRecurringIcon = (item) => {
        if(!this.props.serverStaticData.hasRecurringItems || !this.props.recurringOrderItems) {
            return null;
        }
        const recurringItem = this.props.recurringOrderItems.find(function(i) {
            return item.key === i.key;
        });
        if (!recurringItem || !recurringItem.schedule) {
            return null;
        }
        return (
            <svg className="recurring-item-icon" version="1.0" xmlns="http://www.w3.org/2000/svg"
                 width="16.000000px" height="16.000000px" viewBox="0 0 714.639 595.281"
                 enableBackground="new 0 0 714.639 595.281">
                <g>
                    <path d="M486.796,483.129c-39.451,27.563-85.475,41.473-132.51,40.715c-6.322,0-12.391-0.506-18.46-1.012 c-2.529-0.252-5.058-0.506-7.586-1.012c-4.806-0.76-9.61-1.266-14.415-2.275c-2.782-0.506-5.816-1.264-8.598-2.023
                    c-4.553-1.012-9.104-2.275-13.657-3.541c-2.276-0.758-4.299-1.516-6.322-2.021c-5.058-1.771-10.368-3.541-15.426-5.564 c-1.265-0.506-2.276-1.012-3.288-1.518c-5.816-2.527-11.632-5.311-17.196-8.344c-0.253-0.254-0.506-0.254-0.759-0.506
                    c-18.966-10.369-36.162-23.518-51.334-38.438c-0.253-0.254-0.506-0.506-0.759-0.76c-4.805-4.807-9.104-9.609-13.402-14.92 c-1.012-1.014-1.771-2.275-2.782-3.287c-30.852-38.691-49.565-87.75-49.565-140.855h59.427l-94.83-142.877L0.001,297.768h59.427
                    c0,62.713,19.472,120.623,52.599,168.67c0.506,0.762,0.759,1.52,1.264,2.023c3.541,4.805,7.334,9.357,10.874,14.162 c1.265,1.77,2.782,3.539,4.046,5.311c5.311,6.574,11.127,12.645,17.196,18.713c0.505,0.508,1.011,1.266,1.517,1.771
                    c19.978,19.977,42.484,36.668,66.76,50.07c0.759,0.252,1.265,0.758,2.023,1.012c7.081,3.793,14.161,7.08,21.748,10.367 c1.77,0.76,3.54,1.77,5.563,2.527c6.322,2.529,12.644,4.807,19.219,7.08c3.035,1.014,6.069,2.023,9.356,3.035
                    c5.563,1.771,11.38,3.035,17.449,4.553c3.793,1.014,7.839,1.771,11.633,2.527c1.518,0.254,3.287,0.76,4.805,1.012 c5.563,1.014,11.127,1.52,16.69,2.277c2.022,0.252,4.046,0.504,6.069,0.758c9.861,1.012,19.725,1.52,29.586,1.52
                    c60.438,0,119.612-18.461,170.188-53.863c16.185-11.381,19.978-33.633,8.853-49.818C525.234,475.543,502.98,471.75,486.796,483.129"/>
                    <path d="M654.708,297.768c0-62.461-19.473-120.371-52.348-168.166c-0.504-0.758-0.759-1.77-1.265-2.529 c-4.047-5.816-8.598-11.379-13.149-16.69c-0.506-0.759-1.011-1.265-1.517-2.023c-30.094-36.667-68.024-64.99-111.016-83.451
                    c-1.264-0.506-2.275-1.011-3.539-1.517c-6.828-2.782-13.91-5.311-20.99-7.839c-2.528-0.759-5.057-1.77-7.586-2.529 c-6.067-1.77-12.391-3.288-18.713-4.805c-3.541-0.759-7.082-1.77-10.369-2.276c-1.77-0.253-3.287-0.759-5.057-1.265
                    c-4.805-0.758-9.357-1.264-14.162-1.77c-3.287-0.253-6.574-1.012-9.861-1.264c-7.84-0.759-15.68-1.012-23.518-1.265 c-1.518,0-2.783-0.253-4.301-0.253c-0.252,0-0.504,0-0.759,0c-60.438,0-119.358,18.208-169.936,53.611
                    c-16.184,11.379-19.978,33.633-8.851,49.817c11.379,16.184,33.633,19.978,49.817,8.851c38.943-27.311,84.716-41.219,131.244-40.713 c6.828,0,13.402,0.505,19.979,1.011c2.022,0.253,4.045,0.506,6.067,0.759c5.312,0.758,10.621,1.517,15.933,2.529
                    c2.274,0.506,4.553,1.011,6.827,1.517c5.058,1.265,10.367,2.529,15.427,4.046c1.518,0.505,3.035,1.011,4.805,1.517 c5.816,1.77,11.379,3.793,16.943,6.322c0.506,0.253,1.264,0.506,1.77,0.759c33.381,14.414,62.461,36.415,85.221,63.979
                    c0.253,0.253,0.253,0.506,0.507,0.506c32.114,38.944,51.334,89.014,51.334,143.383H524.22l95.336,142.877l95.082-142.877 L654.708,297.768L654.708,297.768z"/>
                </g>
            </svg>
        )
    };

    render() {
        const item = this.props.item || {};
        const extraCreditItem = ((this.props.creditsData || {}).extraCreditItem || {});
        const price = item.isCredit && !this.props.serverStaticData.isCreditItemAsRegularItem ? item.price + " " + this.props.serverStaticData.creditItemLabel :
            formatMoney(getItemPrice(item, this.props.serverStaticData).priceBeforeTax);
        if (item.key === extraCreditItem.key && this.props.serverStaticData.isCreditItemAsRegularItem) {
            return null;
        }
        return (<div className="order-summary-item-wrapper">
            <div className={this.props.clientViewPort.isXs ? "order-summary-item" : "order-summary-item"}>
                {this.getRecurringIcon(item)}
                <img src={item.imageUrl} onError={setNoItemImage} onClick={() => this.openDetails(item)}/>
                {this.props.clientViewPort.isXs ?
                    <div className="details-wrapper">
                        {this.getDetails(item, price, extraCreditItem)}
                        {this.getQuantityAndTotal(item, price, extraCreditItem)}
                    </div> :
                    this.getDetails(item, price, extraCreditItem)
                }
                {!this.props.clientViewPort.isXs ? this.getQuantityAndTotal(item, price, extraCreditItem) : ""}
                {
                    this.props.readonly || item.key === extraCreditItem.key
                        ? undefined
                        : <div>
                            <button className="delete-button order-summary-item-remove hidden-xs"
                                    name="btnOrderSummaryItemRemove" onClick={this.onRemoveButtonClick}/>
                        </div>
                }
            </div>
            <hr className="summary-item-divider"/>
        </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        serverStaticData: state.staticData,
        clientViewPort: (state.clientViewPort || {}),
        recurringOrderItems: (state.recurringOrder || {}).items,
        allItems: state.itemsList || {}
    }
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeItemQuantity: (item, newQuantity, oldQuantity, creditData) => {
			dispatch(changeItemQuantity(item, newQuantity, oldQuantity, creditData));
            // dispatch(GA.trackGAEvent(GA.GA_CATEGORIES.STORE, GA.GA_ACTIONS.ITEM_REMOVED, GA.GA_LABELS.CART));
		},
        openDetailsBox: (category, item) => {
            dispatch(push(location.pathname+CART_ITEM_QRY+"="+item+CATEGORY_QRY+"="+category));
        },
	}
};

export default  connect(mapStateToProps, mapDispatchToProps)(StoreOrderSummaryItem);


// WEBPACK FOOTER //
// ./src/containers/store/StoreOrderSummaryItem.js